module.exports = __webpack_public_path__ + "static/media/warning.5b5b51e6.png";